import React from "react";
import { Layout, Tabs, Row, Col } from "antd";
import "./nav-bar.less";
import { NavBarProps } from "./types";
import { Routes } from "routes";
import { withRouter } from "react-router-dom";

class NavBar extends React.Component<NavBarProps> {
  render() {
    return (
      <Layout>
        <Layout.Header className={`nav-bar__container ${this.props.className}`}>
          <Row>
            <Col xs={1} sm={1} md={2} lg={3} xl={4} xxl={5}></Col>
            <Col xs={22} sm={22} md={20} lg={18} xl={16} xxl={14}>
              <Tabs onTabClick={this.navigate.bind(this)} defaultActiveKey={this.mapRouteToKey(this.props.location.pathname)}>
                <Tabs.TabPane tab={'What we do'} key="1" />
                <Tabs.TabPane tab={'Who we are'} key="2" />
                <Tabs.TabPane tab={'Connect with us'} key="3" />
              </Tabs>
            </Col>
            <Col xs={1} sm={1} md={2} lg={3} xl={4} xxl={5}></Col>
          </Row>
        </Layout.Header>
      </Layout>
    );
  }

  private mapRouteToKey(route: string): string {
    switch(route) {
      case Routes.TEAM: return '2';
      case Routes.CONTACT: return '3';
      default: return '1';
    }
  }

  private mapKeyToRoute(key: string): string {
    switch(key) {
      case '2': return Routes.TEAM;
      case '3': return Routes.CONTACT;
      default: return Routes.SOLUTION;
    }
  }

  private navigate(key: string): void {
    this.props.history.push(this.mapKeyToRoute(key));
  }
}

export default withRouter(NavBar);
